import camelcaseKeys from "camelcase-keys";
import { onUpload } from "services/apis/upload";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const doUploadAvatar = createAsyncThunk(
  "upload/uploadAvatar",
  async params => {
    const result = await onUpload(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

const initialState = {
  isSaving: false,
};

const slice = createSlice({
  name: "upload",
  initialState: initialState,
  reducers: {},
  extraReducers: {},
});

const { reducer } = slice;

export default reducer;
